<div class="action" (click)="setActive($event)" [ngClass]="{'active': active, 'locked': conflict}"
     (clickOutside)="resetActive()">
    @if (label) {
        <div class="action-label-title">
            {{ label }}
        </div>
    }
    <div class="action-media">
        <ng-content class="action-media-object" select="fui-icon"></ng-content>
    </div>
    @if (title) {
        <div class="action-modal">
            <div class="action-modal-window">
                <div class="action-modal-window-content" id="label">
                    {{ title | translate }}
                </div>
            </div>
        </div>
    }
</div>
@if (active) {
    <div class="modal" [@fade] [style.max-height]="'calc(100vh - ' + mainTopPosition + ')'">
        <div class="modal-window">
            <div class="modal-window-main">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
}
